import { render, staticRenderFns } from "./DatabaseIcon.vue?vue&type=template&id=259a4d16&scoped=true&"
import script from "./DatabaseIcon.vue?vue&type=script&lang=js&"
export * from "./DatabaseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259a4d16",
  null
  
)

export default component.exports